import { render, staticRenderFns } from "./VideoParentOther.vue?vue&type=template&id=3260ef8a&scoped=true"
import script from "./VideoParentOther.vue?vue&type=script&lang=js"
export * from "./VideoParentOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3260ef8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3260ef8a')) {
      api.createRecord('3260ef8a', component.options)
    } else {
      api.reload('3260ef8a', component.options)
    }
    module.hot.accept("./VideoParentOther.vue?vue&type=template&id=3260ef8a&scoped=true", function () {
      api.rerender('3260ef8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/parent/video/VideoParentOther.vue"
export default component.exports